module.exports = __webpack_public_path__ + "static/media/2.a5c6a0c4.png";